<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qF2VZY/tc-custom/9781429950305.jpg?1734286303875" alt="This image is the cover for the book Ninth Talisman, The Annals of the Chosen"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ninth Talisman, The Annals of the Chosen
      </h1>
      <p class="bookDescription body article font2">
        <p> All of the world is kept in a delicate balance under the supervision of the Wizard Lord. It is his duty to govern lightly and protect his domain … but if he should stray from the way of the just, then it is up to the Chosen to intercede.<br/><br/> The Chosen are the Leader, the Seer, the Swordsman, the Beauty, the Thief, the Scholar, the Archer, and the Speaker. These are magically infused mortal individuals who for the term of their service have only one function—to remove an errant Wizard Lord.<br/><br/> The Chosen fulfilled this role when they removed the previous Wizard Lord and exposed treachery from within their own ranks.<br/><br/> Since their last adventure, the world has returned to apparent peace and prosperity. The new Wizard Lord rules benevolently … but with an eye towards modernization through technology, instead of magic.<br/><br/> Do such plans jeopardize the delicate balance of power?<br/><br/> Is a Wizard Lord who is able to rule without magic a threat to the Chosen?<br/>   </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lawrence Watt-Evans
      </h2>
      
      <p class="authorDescription body article"><P>LAWRENCE WATT-EVANS has written more than a dozen fantasy novels. He lives in Maryland.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2b855458